import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule } from '@angular/forms' // <-- Add this import
import { DragDropModule } from '@angular/cdk/drag-drop'
import { InternalPageComponent } from './internal-page/internal-page.component'
import { ObservationsDataComponent } from './components/vzo-layer-categories/observations-data/observations-data.component'
import { ClusteredSignsDataComponent } from './components/vzo-layer-categories/clustered-signs-data/clustered-signs-data.component'
import { ClusteredSignsDetailsComponent } from './components/clustered-signs-details/clustered-signs-details.component'
import { RolloutsTileDataComponent } from './components/vzo-layer-categories/rollouts-tile-data/rollouts-tile-data.component'
import { RolloutsTileSegmentDetailsComponent } from './components/rollouts-map-tile-segment-details/rollouts-map-tile-segment-details.component'
import { RolloutsTileMatchedSignsDetailsComponent } from './components/rollouts-map-tile-matched-signs-details/rollouts-map-tile-matched-signs-details.component'
import { RolloutsTileFilteredMatchedSignsDetailsComponent } from './components/rollouts-map-tile-filtered-matched-signs-detail/rollouts-map-tile-filtered-matched-signs-details.component'
import { ObservationsDetailsComponent } from './components/observations-details/observations-details.component'
import { VZODataLayerConfigComponent } from './components/vzo-data-layer-config/vzo-data-layer-config.component'
import { SharedModule } from '../shared/shared.module'
import { InternalLegendComponent } from './components/internal-legend/internal-legend.component'
import { MatchedSignsDetailsComponent } from './components/matched-signs-details/matched-signs-details.component'
import { DetailsAccordionComponent } from '../shared/components/details/details-accordion/details-accordion'
import { TripStatisticsDataComponent } from './components/vzo-layer-categories/trip-statistics-data/trip-statistics-data.component'
import { ConstructionSitesDataComponent } from './components/vzo-layer-categories/construction-sites-data/construction-sites-data.component'
import { ConstructionSitesDetailsComponent } from './components/construction-sites-details/construction-sites-details.component'
import { DetailsToggleModule, DropdownModule } from '@inst-iot/bosch-angular-ui-components'
import { NgbDropdownModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap'
import { SignSimulationDialogComponent } from './components/sign-simulation-dialog/sign-simulation-dialog.component'
import { InternalHistoryControlComponent } from './components/internal-history-control/internal-history-control.component'
import { BlacklistAreaDialogComponent } from './components/blacklist-area-dialog/blacklist-area-dialog.component'
import { RoadCoverageComponent } from './components/vzo-layer-categories/road-coverage-data/road-coverage-data.component'
import { RoadCoverageSegmentDetailsComponent } from './components/road-coverage-segment-details/road-coverage-segment-details.component'
import { SpeedProfileSegmentDetailsComponent } from './components/speed-profile-segment-details/speed-profile-segment-details.component'
import { NonDetectionsDetailsComponent } from './components/non-detections-details/non-detections-details.component'

@NgModule({
  declarations: [
    InternalPageComponent,
    VZODataLayerConfigComponent,
    ObservationsDataComponent,
    ObservationsDetailsComponent,
    ClusteredSignsDataComponent,
    ClusteredSignsDetailsComponent,
    RolloutsTileDataComponent,
    RolloutsTileSegmentDetailsComponent,
    RolloutsTileMatchedSignsDetailsComponent,
    RolloutsTileFilteredMatchedSignsDetailsComponent,
    TripStatisticsDataComponent,
    InternalLegendComponent,
    MatchedSignsDetailsComponent,
    ConstructionSitesDetailsComponent,
    ConstructionSitesDataComponent,
    SignSimulationDialogComponent,
    InternalHistoryControlComponent,
    BlacklistAreaDialogComponent,
    RoadCoverageComponent,
    RoadCoverageSegmentDetailsComponent,
    SpeedProfileSegmentDetailsComponent,
    NonDetectionsDetailsComponent,
  ],
  imports: [
    CommonModule,
    FormsModule, // <-- Add this line
    DragDropModule,
    DetailsToggleModule,
    DropdownModule,
    SharedModule,
    DetailsAccordionComponent,
    NgbDropdownModule,
    NgbTooltipModule,
  ],
})
export class InternalModule {}
